import React from 'react';
import parse from 'html-react-parser';
import { removeBreaksAndEmptyParagraphs } from '../../../utils/removeBreaksAndEmptyParagraphs';

export type Props = {
  isActive: boolean;
  html: string | null;
};

const Description: React.FunctionComponent<Props> = ({ html, isActive }: Props) => {
  return isActive === true && typeof html === 'string' && html.length > 0
    ? <div>
      {parse(removeBreaksAndEmptyParagraphs(html ?? ''))}
    </div>
    : null;
};

export default Description;
